import { useEffect } from 'react';
import { Button } from '@ownyou/ui-components';
import { createMissionSpineRunId, recordMissionSpineMarker } from '../../lib/mission-spine/instrumentation';

interface CommitSheetProps {
  actionLabel: string;
  isSubmitting?: boolean;
  onCancel: () => void;
  onConfirm: () => void | Promise<void>;
}

export function CommitSheet({ actionLabel, isSubmitting = false, onCancel, onConfirm }: CommitSheetProps) {
  useEffect(() => {
    recordMissionSpineMarker({
      runId: createMissionSpineRunId('slice-02-action-modal'),
      hop: 'action_modal',
      status: 'success',
      reasonCode: 'commit_sheet_rendered',
      counts: { modalCount: 1 },
    }, { log: false });
  }, []);

  return (
    <section data-testid="commit-sheet" className="rounded-xl border border-sky-500/30 bg-sky-500/10 p-4 space-y-3">
      <div>
        <h2 className="text-base font-semibold text-slate-100">Commit to this mission</h2>
        <p className="mt-1 text-sm text-slate-400">
          Confirm the local action before marking this mission as accepted.
        </p>
      </div>
      <div className="flex flex-col gap-2 sm:flex-row">
        <Button
          data-testid="commit-confirm"
          variant="primary"
          onClick={onConfirm}
          disabled={isSubmitting}
          className="flex-1"
        >
          {isSubmitting ? 'Confirming…' : actionLabel}
        </Button>
        <Button
          data-testid="commit-cancel"
          variant="secondary"
          onClick={onCancel}
          disabled={isSubmitting}
          className="flex-1"
        >
          Cancel
        </Button>
      </div>
    </section>
  );
}
